module.exports = __webpack_public_path__ + "img/06-0资质4.d2f165a3.png";